import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4165f644"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { id: "offerCardsList" }
const _hoisted_3 = {
  key: 1,
  class: "container center align-center mt--20 mb--20"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bubble bubble__right m-font-size" }, " По вашему запросу ничего не найдено, попробуйте изменить запрос ", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "mt--20"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "items-in-column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Добавлено к сравнению", -1))

import qs from 'qs';
import { computed, inject, onBeforeMount, onMounted, Ref, ref, watch } from 'vue';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { ResultCardType, SortIdsType } from '@/types';
import { MapBlock } from '@/components';
import { OfferCardsBlock } from '@/components/Cards';
import { BannerComponent } from '@/components/MainPageComponents';
import { OfferCardCoordinatesType } from '@/api/house/types';
import { useRoute } from 'vue-router';
import { useAppStore } from '@/store/modules/app';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';

type ParamsByQueryType = {
  [key: string]: {
    value?: string;
    min?: string;
    max?: string;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

const resultCardsCoordinates = computed((): OfferCardCoordinatesType[] => {
  return useOfferCardsStore().offerCardsCoordinates;
});

const suitableCards = computed((): ResultCardType[] => {
  return useOfferCardsStore().offerCards;
});
const similarCards = computed((): ResultCardType[] => {
  return useOfferCardsStore().similarCards;
});
const centerPointMap = computed(() => {
  return useOfferCardsStore().centerPointMap;
});
const isShowMapBlock = computed(() => {
  return useOfferCardsStore().isShowMapBlock;
});
const activeFilterBtn = computed(() => {
  return useOfferCardsStore().activeFilterBtn;
});
const showInfoModal: Ref<boolean> = ref(false);
const showInfoModalKey: Ref<number> = ref(1);

const paginationPage = ref(1);

const searchOfferCardsData = computed(() => {
  return useOfferCardsStore().searchOfferCardsData;
});
const isShowResultBlock = computed(() => {
  return useOfferCardsStore().isShowResultBlock;
});
const isMoreLoading = computed(() => {
  return useOfferCardsStore().isMoreLoading;
});
const isLoadingResultBlock = computed(() => {
  return useOfferCardsStore().isLoadingResultBlock;
});
const isSimilarLoading = computed(() => {
  return useOfferCardsStore().isSimilarLoading;
});

const route = useRoute();

const sortResultBlock = (id: SortIdsType) => {
  paginationPage.value = 1;
  useOfferCardsStore().updateSortParam(id);
  useOfferCardsStore().getOfferCards();
};

const changePageAndPageSize = (data: {
  page: number;
  pageSize: number;
  showMore?: boolean;
}) => {
  if (
    data.pageSize !== searchOfferCardsData.value.pageSize ||
    data.page !== searchOfferCardsData.value.page
  ) {
    paginationPage.value = data.page;
    useOfferCardsStore().updatePageSizeParams(data.page, data.pageSize);
    useOfferCardsStore().getOfferCards(data.showMore);
  }
};
const isLoadingTopBlock: Ref<boolean> = ref(false);

const getParamsByUrl = () => {
  // Достаем значения фильтров из URL
  const queryParams = route?.query as string | undefined;

  if (queryParams) {
    const inputsParams = qs.parse(queryParams) as ParamsByQueryType;

    Object.entries(inputsParams).forEach(param => {
      useOfferCardsStore().updateParameter(
        param[0],
        param[1]?.value ?? null,
        param[1]?.min ? +param[1]?.min : null,
        param[1]?.max ? +param[1]?.max : null,
      );
    });
  }

  // Если параметров больше 0, то отображаем результат
  if (Object.keys(useOfferCardsStore().params).filter(el => el !== '306').length) {
    useOfferCardsStore().updateSearchOfferCardsData();
    useOfferCardsStore().getOfferCards();
  }
};

onBeforeMount(async () => {
  getParamsByUrl();
  if (!useOfferCardsStore().filterBtnsByType.length) {
    await useOfferCardsStore().getTopHouse();
  } else {
    useOfferCardsStore().getActiveFilterBtn();
  }
});
const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;

onMounted(() => {
  const hash = route?.hash;

  if (hash === '#list') {
    const myEl = document.getElementById('offerCardsList');

    if (myEl) {
      smoothScroll({
        scrollTo: myEl,
        offset: 0,
        updateHistory: false,
      });
    }
    useOfferCardsStore().showResultBlock();
  }
});

watch(
  () => useAppStore().regions_for_select.defaultForUser,
  async () => {
    await useOfferCardsStore().getTopHouse();
    if (isShowResultBlock.value) {
      useOfferCardsStore().updateSearchOfferCardsData();

      await useOfferCardsStore().getOfferCards();
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BannerComponent)),
    _createElementVNode("div", {
      class: _normalizeClass([{ show: isShowMapBlock.value }, "main__map-block none-Mobile"])
    }, [
      _createVNode(_unref(MapBlock), {
        centerPointMap: centerPointMap.value,
        resultCardsCoordinates: resultCardsCoordinates.value,
        showOfferCard: ""
      }, null, 8, ["centerPointMap", "resultCardsCoordinates"]),
      _createVNode(_component_base_button, {
        class: "main__map-block-close",
        height: "40",
        icon: "",
        width: "40",
        withoutActive: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(useOfferCardsStore)().hideMapBlock()))
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_base_icon, {
            clickable: "",
            color: "#ffffff",
            "font-size": "30",
            name: "close"
          })
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      ((isShowResultBlock.value && suitableCards.value.length) || isLoadingResultBlock.value)
        ? (_openBlock(), _createBlock(_unref(OfferCardsBlock), {
            key: 0,
            isLoading: isLoadingResultBlock.value,
            isMoreLoading: isMoreLoading.value,
            paginationPage: paginationPage.value,
            resultCards: suitableCards.value,
            "title-with-line": "",
            onChangePageAndPageSize: _cache[1] || (_cache[1] = ($event: any) => (changePageAndPageSize($event))),
            onSortResultBlock: _cache[2] || (_cache[2] = ($event: any) => (sortResultBlock($event)))
          }, null, 8, ["isLoading", "isMoreLoading", "paginationPage", "resultCards"]))
        : (isShowResultBlock.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
    ]),
    (similarCards.value.length || isSimilarLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(OfferCardsBlock), {
            isLoading: isSimilarLoading.value,
            resultCards: similarCards.value,
            class: "main__top-block",
            isTop: "",
            title: "Похожие объявления",
            "title-with-line": ""
          }, null, 8, ["isLoading", "resultCards"])
        ]))
      : _createCommentVNode("", true),
    (activeFilterBtn.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeFilterBtn.value?.topBlocks, (topBlock, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              (topBlock.data.length)
                ? (_openBlock(), _createBlock(_unref(OfferCardsBlock), {
                    key: 0,
                    isLoading: isLoadingTopBlock.value,
                    resultCards: topBlock.data,
                    title: topBlock.title,
                    class: "main__top-block",
                    isTop: "",
                    "title-with-line": ""
                  }, null, 8, ["isLoading", "resultCards", "title"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
            return _createElementVNode("div", { key: i }, [
              _createVNode(_unref(OfferCardsBlock), {
                isLoading: true,
                "result-cards": [],
                class: "main__top-block",
                isTop: ""
              })
            ])
          }), 64))
        ])),
    (_openBlock(), _createBlock(_component_base_info_modal, {
      key: showInfoModalKey.value,
      "show-info-modal": showInfoModal.value,
      position: "top-right",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showInfoModal.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_router_link, {
            to: { name: 'compare' },
            class: "underline white-color"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Перейти к сравнению ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show-info-modal"]))
  ]))
}
}

})